import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  requestTaskSchedulers: `${NAMESPACE}_REQUEST_TASK_SCHEDULERS`,
  requestTaskSchedulersSuccess: `${NAMESPACE}_REQUEST_TASK_SCHEDULERS_SUCCESS`,
  executeTaskScheduler: `${NAMESPACE}_EXECUTE_TASK_SCHEDULER`,
  executeTaskSchedulerSuccess: `${NAMESPACE}_EXECUTE_TASK_SCHEDULER_SUCCESS`,
  executeTaskSchedulerError: `${NAMESPACE}_EXECUTE_TASK_SCHEDULER_ERROR`,
  requestTaskSchedulerLogs: `${NAMESPACE}_REQUEST_TASK_SCHEDULER_LOGS`,
  requestTaskSchedulerLogsSuccess: `${NAMESPACE}_REQUEST_TASK_SCHEDULER_LOGS_SUCCESS`,
  closeTaskSchedulerLogs: `${NAMESPACE}_CLOSE_TASK_SCHEDULER_LOGS`,
  clearTaskSchedulerState: `${NAMESPACE}_CLEAR_TASK_SCHEDULER_STATE`,
  hideTaskSchedulerAlert: `${NAMESPACE}_HIDE_TASK_SCHEDULER_ALERT`,
};

export const actionCreators = {
    requestTaskSchedulers: payload => ({ type: actions.requestTaskSchedulers, payload }),
    requestTaskSchedulersSuccess: payload => ({ type: actions.requestTaskSchedulersSuccess, payload }),
    executeTaskScheduler: payload => ({ type: actions.executeTaskScheduler, payload }),
    executeTaskSchedulerSuccess: payload => ({ type: actions.executeTaskSchedulerSuccess, payload }),
    executeTaskSchedulerError: payload => ({ type: actions.executeTaskSchedulerError, payload }),
    requestTaskSchedulerLogs: payload => ({ type: actions.requestTaskSchedulerLogs, payload }),
    requestTaskSchedulerLogsSuccess: payload => ({ type: actions.requestTaskSchedulerLogsSuccess, payload }),
    closeTaskSchedulerLogs: payload => ({ type: actions.closeTaskSchedulerLogs, payload }),
    hideTaskSchedulerAlert: payload => ({ type: actions.hideTaskSchedulerAlert, payload }),
    clearTaskSchedulerState: payload => ({ type: actions.clearTaskSchedulerState, payload }),
};

export default {
    actions,
    actionCreators,
};
